import { render, staticRenderFns } from "./feedAddDialog.vue?vue&type=template&id=4673f953&"
import script from "./feedAddDialog.vue?vue&type=script&lang=js&"
export * from "./feedAddDialog.vue?vue&type=script&lang=js&"
import style0 from "./feedAddDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports